import React, { useState, useContext, useEffect } from 'react';
import { Paper } from '@material-ui/core';
import { Line } from 'react-chartjs-2';
import { Context as CountriesContext } from '../context/CountriesContext';
import { Context as StatContext } from '../context/StatContext';
import { findCountry, isGlobal, buildLineGraph, statOptions } from '../utils';
import diseaseApi from '../api/disease';
import numeral from 'numeral';
import '../styles/LineGraph.css';
import { Input } from '@material-ui/core';

const options = {
  legend: {
    display: false
  },
  elements: {
    point: {
      radius: 0
    }
  },
  responsive: true,
  maintainAspectRatio: false,
  tooltips: {
    mode: 'index',
    intersect: false,
    callbacks: {
      label: function (tooltipItem, data) {
        return numeral(tooltipItem.value).format('+0,0');
      }
    }
  },
  scales: {
    xAxes: [
      {
        type: 'time',
        time: {
          format: 'MM/DD/YY',
          tooltipFormat: 'll'
        }
      }
    ],
    yAxes: [
      {
        gridLines: {
          display: false
        },
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, values) {
            return numeral(value).format('0a');
          }
        }
      }
    ]
  }
};

const TIME_PERIOD = 120;
function LineGraph() {
  const {
    state: { countries, selectedCountry }
  } = useContext(CountriesContext);
  const { statType } = useContext(StatContext);
  const [histData, setHistData] = useState({});
  const [timePeriod, setTimePeriod] = useState(TIME_PERIOD);
  const country = findCountry(countries, selectedCountry);
  useEffect(() => {
    const fetchHistoricalData = async () => {
      // 'all' stands for Global
      const url = `/historical/${
        isGlobal(country) ? 'all' : country.country
      }?lastdays=${timePeriod}`;
      const response = await diseaseApi.get(url);
      setHistData(response.data);
    };
    fetchHistoricalData();
  }, [selectedCountry, timePeriod, country]);

  const changeTimePeriod = event => setTimePeriod(event.target.value);

  const data = histData.timeline || histData;
  const textColor = statOptions[statType].color;
  return (
    <Paper className="linegraph">
      <h1
        style={{
          color: textColor
        }}>{`${country.country} new ${statType}`}</h1>
      <p style={{ color: textColor }}>Last {timePeriod} Days</p>
      <Input value={timePeriod} onChange={changeTimePeriod} type="number" />
      <Line
        data={canvas => buildLineGraph(canvas, country, data, statType)}
        options={options}
        type="area"
        toolTipContent
      />
    </Paper>
  );
}

export default LineGraph;
